import React, { useState } from 'react'
import { NavLink, Outlet, useLoaderData } from 'react-router-dom';
import ItemAwait from 'components/Item/ItemAwait';
import ItemHeader from 'components/Item/ItemHeader';
import ItemContent from 'components/Item/ItemContent';
import ItemFooter from 'components/Item/ItemFooter';
import ItemPlaceHolder from 'components/Item/ItemPlaceHolder';
import Tooltip from 'components/Tooltip/Tooltip';
import { Trans, useTranslation } from 'react-i18next';

const Project = () => {
	const { project } = useLoaderData();
	const [item, setItem] = useState();
	const { t } = useTranslation();

	//callback function of Await react-router-dom
	const resolvedPromise = (response) => {
		if (response != null && response.data != null && response.data.length != 0) {
			setItem(response.data);
		}
	}

	return (
		<ItemAwait resolvePromise={project} hasResolved={resolvedPromise} loading={<ItemPlaceHolder />}>
			<ItemHeader
				avatar={item?.avatar}
				title={item?.fullname}
				subtitle={item?.azienda}
			>
				<Tooltip title={t('views:projects.item.header.edit')} >
					<NavLink to='edit' className='btn btn-outline-primary btn-sm disabled'>
						<i className='mdi mdi-pencil' />
						<Trans i18nKey='views:projects.item.header.edit' />
					</NavLink>
				</Tooltip>
			</ItemHeader>
			<ItemContent>
				<Outlet context={[item]} />
			</ItemContent>
			<ItemFooter />
		</ItemAwait>
	)
}

export default Project